import { Accordion } from "react-bootstrap";
import { FORM_KEYS } from "./helper";
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { REGEX } from "../../../../consts";
import { useEffect, useState } from "react";

const OtherExistingPolicyDetails = ({
    customStyles, formData, setExistingPolicyDetails, setFormData, setValue, defaultExistingPolicyDetails, coverageTypes
}) => {
    const [disableAddButton, setDisableAddButton] = useState(false)

    const handleAddPolicy = () => {
        setFormData((prev) => ({
            ...prev,
            existingPolicyDetails: [...prev.existingPolicyDetails, defaultExistingPolicyDetails]
        }));
    }

    const handleDeletePolicy = (indexToDelete) => {
        setFormData((prev) => ({
            ...prev,
            existingPolicyDetails: prev.existingPolicyDetails.filter((_, index) => index !== indexToDelete)
        }));

    }

    const handleDateChange = (date, key, index) => {
    if (date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const dat1 = date.getDate().toString().padStart(2, "0");
        setExistingPolicyDetails(index, key, `${year}-${month}-${dat1}`)
    }
  };

  useEffect(()=>{
    const haveOtherPolicies = formData[FORM_KEYS.have_other_policies] === "Yes";
    const existingLastPolicy = formData.existingPolicyDetails[formData.existingPolicyDetails?.length -1]
    if(haveOtherPolicies) {
        const policyNumber = existingLastPolicy[FORM_KEYS.policy_number]?.trim()
        const insurerName = existingLastPolicy[FORM_KEYS.insurer_name]?.trim()
        const sumInsured = existingLastPolicy[FORM_KEYS.sum_insured]?.trim()
        const coverageType = existingLastPolicy[FORM_KEYS.coverage_type];
        const policyStartDate = existingLastPolicy[FORM_KEYS.policy_start_date];
        const policyEndDate = existingLastPolicy[FORM_KEYS.policy_end_date];

        if(!(policyNumber || insurerName || sumInsured || coverageType || policyStartDate || policyEndDate)) {
          setDisableAddButton(true)
        } else {
            setDisableAddButton(false)
        }
    }
  },[formData])
    return <>
            <Accordion className='accordion mt-2 mx-2' defaultActiveKey={0}>
            <Accordion.Item eventKey={0}>
                <Accordion.Header>Other Existing Health Policy Details</Accordion.Header>
                <Accordion.Body>
      
        <div className="mx-3">
            <p>Do you have any other existing health policies?</p>
            <div>
                <input
                    type="radio"
                    style={{ cursor: "pointer", width: "15px", height: "15px" }}
                    name="have_other_policies"
                    onClick={() => {
                        setValue([FORM_KEYS.have_other_policies], "Yes");
                        handleAddPolicy()
                    }}
                    checked={formData?.have_other_policies === "Yes"}
                />
                <span className="mx-2">Yes</span>
                <input
                    type="radio"
                    style={{ cursor: "pointer", width: "15px", height: "15px" }}
                    name="have_other_policies"
                    onClick={() => {
                        setValue([FORM_KEYS.have_other_policies], "No")
                        setValue("existingPolicyDetails", [])
                    }}
                    checked={formData?.have_other_policies === "No"}
                />
                <span className="mx-2">No</span>

            </div>

        </div>
        <div className="mx-2">
            {formData[FORM_KEYS.have_other_policies] === "Yes" ? (
                formData.existingPolicyDetails.map((policyDetails, index) => (
                    <Accordion className='accordion mt-2' defaultActiveKey={formData.existingPolicyDetails?.length - 1}>
                        <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                                <div className="d-flex justify-content-between align-items-center w-100">
                                    <span>Policy - {index + 1}</span>
                                    {formData.existingPolicyDetails.length > 1 && (<i
                                        className="fa fa-trash text-danger pe-4 cursor-pointer"
                                        onClick={() => handleDeletePolicy(index)}
                                        title="Delete"
                                    ></i>)}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="row mt-1">
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                        <p className="align3Policy">Policy Number</p>
                                        <input
                                            className="claim-intimator-textarea mt-2 ms-2"
                                            placeholder="Enter Policy Number "
                                            value={policyDetails[FORM_KEYS.policy_number]}
                                            maxLength={50}
                                            onChange={(e) => setExistingPolicyDetails(index, FORM_KEYS.policy_number, e.target.value)}
                                        />
                                    </div>

                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                        <p className="align3Policy">Insurer Name</p>
                                        <input
                                            className="claim-intimator-textarea mt-2 ms-2"
                                            placeholder="Enter Insurer Name"
                                            value={policyDetails[FORM_KEYS.insurer_name]}
                                            maxLength={100}
                                            onChange={(e) => setExistingPolicyDetails(index, FORM_KEYS.insurer_name, e.target.value)}
                                        />
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                        <p className="align3Policy">Sum Insured (₹)</p>
                                        <input
                                            className="claim-intimator-textarea mt-2 ms-2"
                                            placeholder="Enter Sum Insured"
                                            value={policyDetails[FORM_KEYS.sum_insured]}
                                            maxLength={100}
                                            type="tel"
                                            onChange={(e) => {
                                                const numericValue = e.target.value.replace(REGEX.NUMBER_WITH_DOT, '');
                                                e.target.value = numericValue;
                                                setExistingPolicyDetails(index, FORM_KEYS.sum_insured, e.target.value)
                                            }}
                                        />
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                        <p className="align3Policy">Coverage Type</p>
                                        <Select
                                            classNamePrefix="truncate-placeholder"
                                            options={coverageTypes}
                                            styles={customStyles}
                                            value={policyDetails[FORM_KEYS.coverage_type] ? policyDetails[FORM_KEYS.coverage_type] : null}
                                            onChange={(selectedOption) => {
                                                setExistingPolicyDetails(index, FORM_KEYS.coverage_type, selectedOption);
                                            }}
                                            placeholder="Select Coverage Type"
                                            isClearable
                                        />
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                        <p className="align3Policy">Policy Validity</p>
                                        <div className="row">
                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12" >
                                                <DatePicker
                                                    selected={policyDetails[FORM_KEYS.policy_start_date] ? policyDetails[FORM_KEYS.policy_start_date] : null}
                                                    className="align4_dataPolicy ms-2 w-100"
                                                    onChange={(date) => { handleDateChange(date, FORM_KEYS.policy_start_date, index)}}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="From Date"
                                                    highlightDates={new Date()}
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    scrollableYearDropdown
                                                    yearDropdownItemNumber={100}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </div>
                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <DatePicker
                                                    selected={policyDetails[FORM_KEYS.policy_end_date] ? policyDetails[FORM_KEYS.policy_end_date] : null}
                                                    className="align4_dataPolicy w-100"
                                                    onChange={(date) => { handleDateChange(date, FORM_KEYS.policy_end_date, index)}}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="To Date"
                                                    highlightDates={new Date()}
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    scrollableYearDropdown
                                                    yearDropdownItemNumber={100}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                {index === (formData.existingPolicyDetails?.length -1)  && (<div>
                                    <div className="d-flex gap-2">
                                        <button
                                            className="btn btn-success"
                                            onClick={handleAddPolicy}
                                            disabled={disableAddButton}
                                        >
                                            Add more policies
                                        </button>
                                    </div>
                                </div>)}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                ))
            ) : ""}
        </div>
        </Accordion.Body>
                </Accordion.Item>
                </Accordion>
    </>
}

export default OtherExistingPolicyDetails;